module.exports = __webpack_public_path__ + "media/images/banner/coupons/coupon-zh-hans-e6f8f9cb2caf0eab16c4a2cdb6051ebe.png";